import axios from 'axios';
import config from '../config.json';

const QueryString = require('qs');

export const getReferralCode = (referralCode) => {
    return axios.get(config.BASE_API_URL + '/referral/code/' + referralCode)
};
